import { destination } from '@turf/turf';

/**
 * Builds a closed rectangle ring (GeoJSON [lon, lat] coordinates) centred at a
 * point, with `widthMeters` measured along the `headingDegrees` axis and
 * `lengthMeters` along the perpendicular axis. Used to draw package footprints
 * on the map (placed packages and packages carried on a vehicle).
 */
export function centeredFootprintRing(
  center: [number, number],
  widthMeters: number,
  lengthMeters: number,
  headingDegrees: number,
): number[][] {
  const halfWidth = widthMeters / 2;
  const halfLength = lengthMeters / 2;

  const corner = (widthSign: 1 | -1, lengthSign: 1 | -1): number[] => {
    const alongWidth = destination(center, halfWidth, headingDegrees + (widthSign === 1 ? 0 : 180), { units: 'meters' });
    const alongLength = destination(alongWidth.geometry.coordinates, halfLength, headingDegrees + 90 + (lengthSign === 1 ? 0 : 180), { units: 'meters' });
    return alongLength.geometry.coordinates;
  };

  return [
    corner(-1, -1),
    corner(1, -1),
    corner(1, 1),
    corner(-1, 1),
    corner(-1, -1),
  ];
}
